import { useLayoutEffect, useState } from 'react';

function useBodyHeight() {
  const [height, setHeight] = useState();

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const scrollHeight = document.body.scrollHeight;
      const shouldSetHeight = height !== scrollHeight;
      if (shouldSetHeight) {
        setHeight(scrollHeight);
      }
    });

    resizeObserver.observe(document.body);

    return () => resizeObserver.unobserve(document.body);
  }, []);

  return height;
}

export default useBodyHeight;
